import { PushNotifications } from '@capacitor/push-notifications';
import { Device } from '@capacitor/device';
import { useStore } from '@/states/index';
import { api } from '@/app/api';

export const registerNotifications = async () => {
  if ((await Device.getInfo()).platform === 'web') {return}

  let permStatus

  permStatus = await PushNotifications.checkPermissions()

  if (permStatus.receive === 'prompt') {
    permStatus = await PushNotifications.requestPermissions()
  }

  if (permStatus.receive !== 'granted') {
    throw new Error('User denied permissions!')
  }

  const store = useStore();
  PushNotifications.addListener('registration', token => {
    store.$patch({ pushToken: token.value })

    // Регистрация push-токена от ОС может прийти позже, чем запрос логина
    // уже ушёл на бэкенд (там токена ещё не было) — досылаем его отдельно,
    // если пользователь уже авторизован.
    if (store.authToken) {
      api.put('/v1/users/push-token', { token: token.value }).catch(() => {})
    }
  })

  await PushNotifications.register()
}
